module.exports = __webpack_public_path__ + "img/1 (135).3c0919c5.png";